import { render, staticRenderFns } from "./MgmtPracticeSwitch.vue?vue&type=template&id=813f380a&scoped=true&"
import script from "./MgmtPracticeSwitch.vue?vue&type=script&lang=js&"
export * from "./MgmtPracticeSwitch.vue?vue&type=script&lang=js&"
import style1 from "./MgmtPracticeSwitch.vue?vue&type=style&index=1&id=813f380a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813f380a",
  null
  
)

export default component.exports